import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getProjectOptions } from '../services/projectService';
import { getProjectLoading } from '../../features/project/projectSlice';

const getIndustryOptions = (projectOptions = {}) =>
  (projectOptions.industry || []).map(({ id, name }) => ({
    value: `${id}`,
    label: name,
  }));

const getServiceOptions = (projectOptions = {}) =>
  (projectOptions.service || []).map(({ id, name }) => ({
    value: `${id}`,
    label: name,
  }));

export const useProjectOptionsFromApi = (territoryCode) => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [projectOptions, setProjectOptions] = useState(undefined);
  const isProjectLoading = useSelector(getProjectLoading);

  useEffect(() => {
    if (!isProjectLoading) {
      setIsLoading(true);
      getProjectOptions(territoryCode)
        .then((opts) => {
          setProjectOptions(opts);
          setHasError(false);
          setIsLoading(false);
        })
        .catch(() => {
          setHasError(true);
          setIsLoading(false);
        });
    }
  }, [setIsLoading, isProjectLoading, setProjectOptions, territoryCode]);

  return {
    isLoading,
    hasError,
    industryOptions: getIndustryOptions(projectOptions),
    serviceOptions: getServiceOptions(projectOptions),
  };
};
